import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import connect from '../../utils/connect';
import classNames from '@app/ui/sports-components/utils/classNames';

import getFilters from '../../actions/filters/getFilters';
import combineActions from '../../utils/combineActions';

import { LoadingDots } from '@app/ui';

import ConfirmedSponsor from './confirmedSponsors/ConfirmedSponsors';
import ConfirmedButtons from './confirmedSponsors/Buttons';
import CustomContent from '../custom/CustomContent';
import CustomButtons from '../custom/Buttons';
import { Context } from '../contexts/OnboardingContext';
import { SponsorContext } from '../contexts/SponsorContext';

const SponsorsPanel = ({ getFilters }) => {
    const { t } = useTranslation('settings');
    const { rhId, isLoading } = useContext(Context);

    const { updateFilters, setUpdateFilters, onCustomTab, setCustomTab } =
        useContext(SponsorContext);

    useEffect(() => {
        if (updateFilters) {
            getFilters();
            setUpdateFilters(false);
        }
    }, [updateFilters]);

    useEffect(() => {
        setCustomTab(false);
    }, [rhId]);

    const rootClass = classNames(
        'onboarding-sponsors',
        'gds-flex-grid__item',
        'gds-flex-grid__item--tablet-1',
        'gds-flex-grid__item--mobile-1',
        'gds-flex-grid__item--desktop-2',
        'gds-flex__item--basis-pct-lg-40',
    );

    return (
        <div className={rootClass}>
            <div className="gds-card gds-flex-grid__item--full-height">
                <div className="gds-card__block -p-a-3">
                    <div className="gds-flex gds-flex--align-center gds-flex--justify-between">
                        <div className="gds-flex__item gds-flex__item--grow-0">
                            <p className="gds-text--header-sm gds-text--regular">
                                {t('clientConfiguration.onboarding.sponsors')}
                            </p>
                        </div>
                        {!onCustomTab && <ConfirmedButtons />}
                        {onCustomTab && <CustomButtons type="sponsor" />}
                    </div>

                    {isLoading && (
                        <div
                            className="gds-flex gds-flex--justify-center gds-flex--align-center -m-t-3"
                            style={{ minHeight: '300px', width: '100%' }}
                        >
                            <LoadingDots size="lg" />
                        </div>
                    )}
                    {!isLoading && (
                        <>
                            <nav className="-m-b-2" data-gds-nav-controls="">
                                <ul
                                    className="gds-nav-tabs gds-nav-tabs--secondary gds-nav-tabs--sm gds-nav-tabs--underline"
                                    data-gds-nav="5"
                                >
                                    <li
                                        className={`gds-nav-tabs__list-item gds-nav-tabs__list-item--underline ${
                                            !onCustomTab &&
                                            `gds-nav-tabs__list-item--active`
                                        }`}
                                        data-gds-nav-item=""
                                    >
                                        <a
                                            className="gds-nav-tabs__link gds-nav-tabs__link--underline"
                                            data-gds-nav-button="1"
                                            data-gds-nav-type="tab"
                                            onClick={() => {
                                                setCustomTab(false);
                                            }}
                                        >
                                            {t(
                                                'clientConfiguration.onboarding.confirmedSponsors',
                                            )}
                                        </a>
                                    </li>
                                    <li
                                        className={`gds-nav-tabs__list-item gds-nav-tabs__list-item--underline ${
                                            onCustomTab &&
                                            `gds-nav-tabs__list-item--active`
                                        }`}
                                        data-gds-nav-item=""
                                    >
                                        <a
                                            className="gds-nav-tabs__link gds-nav-tabs__link--underline"
                                            data-gds-nav-button="2"
                                            data-gds-nav-type="tab"
                                            onClick={() => {
                                                setCustomTab(true);
                                            }}
                                        >
                                            {t(
                                                'clientConfiguration.onboarding.customSponsors',
                                            )}
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                            {!onCustomTab && <ConfirmedSponsor />}
                            {onCustomTab && <CustomContent type="sponsor" />}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

SponsorsPanel.propTypes = {
    getFilters: PropTypes.func,
};

export default connect(
    [],
    combineActions({
        getFilters,
    }),
)(SponsorsPanel);
